import React, { useState, useEffect, useRef } from "react";

const PopupComponent = () => {
  const [dontShowDoMyBestAgain, setDontShowDoMyBestAgain] = useState(false);
  const [dontShowMayFamilyMonthAgain, setDontShowMayFamilyMonthAgain] =
    useState(false);
  const [dontShowHolidayAgain, setDontShowHolidayAgain] = useState(false);

  const [hideDoMyBestTemp, setHideDoMyBestTemp] = useState(false);
  const [hideMayFamilyMonthTemp, setHideMayFamilyMonthTemp] = useState(false);
  const [hideHolidayTemp, setHideHolidayTemp] = useState(false);

  const doMyBestRef = useRef(null);
  const mayFamilyMonthRef = useRef(null);
  const holidayRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // 도전 팝업만 닫는 조건
      if (
        shouldShowPopup("DoMyBest") &&
        doMyBestRef.current &&
        !doMyBestRef.current.contains(event.target)
      ) {
        if (
          !mayFamilyMonthRef.current ||
          !mayFamilyMonthRef.current.contains(event.target)
        ) {
          setHideDoMyBestTemp(true);
        }
      }

      // 가정의달 팝업만 닫는 조건
      if (
        shouldShowPopup("MayFamilyMonth") &&
        mayFamilyMonthRef.current &&
        !mayFamilyMonthRef.current.contains(event.target)
      ) {
        if (
          !doMyBestRef.current ||
          !doMyBestRef.current.contains(event.target)
        ) {
          setHideMayFamilyMonthTemp(true);
        }
      }

      // 휴일 팝업만 닫는 조건
      if (
        shouldShowPopup("Holiday") &&
        holidayRef.current &&
        !holidayRef.current.contains(event.target)
      ) {
        if (
          (!mayFamilyMonthRef.current ||
            !mayFamilyMonthRef.current.contains(event.target)) &&
          (!doMyBestRef.current || !doMyBestRef.current.contains(event.target))
        ) {
          setHideHolidayTemp(true);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClose = (popup) => {
    const currentTime = new Date().getTime();

    if (popup === "DoMyBest") {
      if (dontShowDoMyBestAgain) {
        localStorage.setItem("hideDoMyBestPopup", currentTime);
      }
      setHideDoMyBestTemp(true);
    } else if (popup === "MayFamilyMonth") {
      if (dontShowMayFamilyMonthAgain) {
        localStorage.setItem("hideMayFamilyMonthPopup", currentTime);
      }
      setHideMayFamilyMonthTemp(true);
    } else if (popup === "Holiday") {
      if (dontShowHolidayAgain) {
        localStorage.setItem("hideHolidayPopup", currentTime);
      }
      setHideHolidayTemp(true);
    }
  };

  const shouldShowPopup = (popup) => {
    const currentTime = new Date().getTime();
    const expirationTime = localStorage.getItem(`hide${popup}Popup`);
    const dayInMilliseconds = 86400000;
    // 그냥 날짜만 변경해서 임시로 넣어둠
    const may6Deadline = new Date("2029-06-06T23:59:59Z").getTime();
    if (popup === "MayFamilyMonth" && currentTime > may6Deadline) {
      return false;
    }

    return (
      !expirationTime ||
      currentTime >= parseInt(expirationTime) + dayInMilliseconds
    );
  };

  return (
    <div>
      {shouldShowPopup("MayFamilyMonth") && !hideMayFamilyMonthTemp && (
        <div className="popup may-family-month-popup" ref={mayFamilyMonthRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/eplus66.png`}
            alt="May Family Month"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowMayFamilyMonthAgain}
                onChange={(e) =>
                  setDontShowMayFamilyMonthAgain(e.target.checked)
                }
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("MayFamilyMonth")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {/* {shouldShowPopup("Holiday") && !hideHolidayTemp && (
        <div className="popup holiday-popup" ref={holidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/new_260126.jpg`}
            alt="Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowHolidayAgain}
                onChange={(e) => setDontShowHolidayAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("Holiday")}
            >
              닫기
            </button>
          </div>
        </div>
      )} */}

      {shouldShowPopup("DoMyBest") && !hideDoMyBestTemp && (
        <>
          {/* <div
            className="popup do-my-best-popup"
            ref={doMyBestRef}
            onMouseDown={(e) => e.stopPropagation()}
          >
          <img
            src={(() => {
              // 현재 시간을 KST(UTC+9)로 변환
              const now = new Date();
              const kstNow = new Date(now.getTime() + 9 * 60 * 60 * 1000);
              const kstTimestamp = kstNow.getTime();

              // 2025-08-15 23:59:59 KST를 UTC로 변환
              const kstDeadline = new Date(
                "2025-08-15T23:59:59+09:00"
              ).getTime();

              return kstTimestamp > kstDeadline
                ? `${process.env.PUBLIC_URL}/image/popup/domybest_after.png`
                : `${process.env.PUBLIC_URL}/image/popup/domybest.png`;
            })()}
            alt="Do My Best"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowDoMyBestAgain}
                onChange={(e) => setDontShowDoMyBestAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={(e) => {
                e.stopPropagation();
                handleClose("DoMyBest");
              }}
            >
              닫기
            </button>
          </div>
        </div>
        */}
        </>
      )}

      <style jsx>{`
        .popup {
          position: absolute;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1000;
          background: #fff;
          border: 1px solid #ccc;
          border-left: none;
        }
        .may-family-month-popup {
          width: 400px;
        }
        .holiday-popup {
          width: 400px;
          left: 400px;
        }
        .do-my-best-popup {
          width: 400px;
          left: 400px;
        }
        .do-my-best-popup img,
        .may-family-month-popup img,
        .holiday-popup img {
          width: 400px;
        }
        .may-family-month-popup img {
          width: 400px;
        }
        .controls-container {
          display: flex;
          justify-content: space-between;
          width: 100%;
          font-size: 12px;
          border: 1px solid #ccc;
        }
        .closePopup {
          background-color: white;
          border: none;
          color: black;
        }
        @media (max-width: 800px) {
          .popup {
            width: 90% !important;
            left: 5% !important;
            top: 100px !important;
          }
          .do-my-best-popup img,
          .may-family-month-popup img,
          .holiday-popup img {
            width: 440px;
          }
        }
      `}</style>
    </div>
  );
};

export default PopupComponent;
